<h2 class="layout-sign-in-regular-title">{{ 'SIGN_IN.CHANGE_PASSWORD.TITLE' | translate }}</h2>

<form [formGroup]="form" fxLayout="column">
  <mat-form-field fxFlex="100%">
    <mat-icon matPrefix>lock</mat-icon>
    <input
      matInput
      formControlName="newPassword"
      type="password"
      [placeholder]="'SIGN_IN.CHANGE_PASSWORD.NEW_PASSWORD' | translate"
      (keyup)="sendPasswordToRules(newPassword.value)"/>
    <mat-error *ngIf="newPassword.invalid">{{ 'SIGN_IN.ERROR_MESSAGE.PASSWORD' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="100%">
    <mat-icon matPrefix>lock</mat-icon>
    <input matInput formControlName="confirmNewPassword" type="password" [placeholder]="'SIGN_IN.CHANGE_PASSWORD.CONFIRM_PASSWORD' | translate" />
    <mat-error *ngIf="confirmNewPassword.invalid">{{ 'SIGN_IN.ERROR_MESSAGE.CONFIRM_PASSWORD' | translate }}</mat-error>
  </mat-form-field>

  <app-sign-in-password-rules [password$]="password$"></app-sign-in-password-rules>

  <div class="layout-sign-in-error" fxLayout="column" [class.error]="hasError">
    <em>Password failed</em>
    <span>{{ hasError }}</span>
  </div>

  <div class="layout-sign-in-form-actions">
    <button class="layout-sign-in-button" type="button" mat-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>

    <button class="progress-bar-button" mat-raised-button [disabled]="!form.valid || loading" (click)="changePassword()">
      <mat-progress-bar
        class="progress-bar-button-gauge"
        [color]="'primary'"
        [mode]="'indeterminate'"
        *ngIf="loading"
      ></mat-progress-bar>
      <span class="progress-bar-button-title" translate>CONFIRM</span>
    </button>
  </div>
</form>
